import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, TrendingUpIcon } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="bg-white border-b border-slate-200 sticky top-0 z-50" data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <div className="flex justify-between h-16" data-id="element-105">
          <div className="flex items-center" data-id="element-106">
            <Link to="/" className="flex items-center gap-2" data-id="element-107">
              <TrendingUpIcon className="text-blue-600" size={28} data-id="element-108" />
              <span className="text-xl font-bold text-slate-900" data-id="element-109">
                CryptoTopReviews
              </span>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-110">
            <Link to="/cryptocurrencies" className="text-slate-700 hover:text-blue-600 font-medium transition-colors" data-id="element-111">
              Cryptocurrencies
            </Link>
            <Link to="/exchanges" className="text-slate-700 hover:text-blue-600 font-medium transition-colors" data-id="element-112">
              Exchanges
            </Link>
            <Link to="/opportunities" className="text-slate-700 hover:text-blue-600 font-medium transition-colors" data-id="element-113">
              Opportunities
            </Link>
            <Link to="/social-media" className="text-slate-700 hover:text-blue-600 font-medium transition-colors" data-id="element-114">
              Social Media
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-115">
            <button onClick={() => setIsOpen(!isOpen)} className="text-slate-700 hover:text-blue-600" data-id="element-116">
              {isOpen ? <XIcon size={24} data-id="element-117" /> : <MenuIcon size={24} data-id="element-118" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden border-t border-slate-200" data-id="element-119">
          <div className="px-2 pt-2 pb-3 space-y-1" data-id="element-120">
            <Link to="/cryptocurrencies" className="block px-3 py-2 text-slate-700 hover:text-blue-600 hover:bg-slate-50 rounded-md font-medium" onClick={() => setIsOpen(false)} data-id="element-121">
              Cryptocurrencies
            </Link>
            <Link to="/exchanges" className="block px-3 py-2 text-slate-700 hover:text-blue-600 hover:bg-slate-50 rounded-md font-medium" onClick={() => setIsOpen(false)} data-id="element-122">
              Exchanges
            </Link>
            <Link to="/opportunities" className="block px-3 py-2 text-slate-700 hover:text-blue-600 hover:bg-slate-50 rounded-md font-medium" onClick={() => setIsOpen(false)} data-id="element-123">
              Opportunities
            </Link>
            <Link to="/social-media" className="block px-3 py-2 text-slate-700 hover:text-blue-600 hover:bg-slate-50 rounded-md font-medium" onClick={() => setIsOpen(false)} data-id="element-124">
              Social Media
            </Link>
          </div>
        </div>}
    </nav>;
}